import AssetsServe from "./AssetsServe";
import React, { useEffect } from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import AcessLoginHavox from "../pages/Acess/LoginHavox";
import AcessoRastreioHavox from "../pages/Acess/AcessoRastreioHavox";
import AcessoRastreioMeusPedidosHavox from "../pages/Laboratorio/Acompanhamento/AcessoRastreioHavox-MeusPedidos";
import AcessCadastro from "../pages/Acess/Cadastro";
import AcessRecuperarSenha from "../pages/Acess/RecuperarSenha";
import SessaoEncerrada from "../pages/Acess/SessaoEncerrada";
import ApiDocPage from "../pages/Api-Documentation/ApiDocsPage";
import MapViewPage from "../pages/map/mapView";
import LaboratorioGestaoDeCases from "../pages/Laboratorio/Acompanhamento/acompanhamento";
import LaboratorioDetalhesCase from "../pages/Laboratorio/Acompanhamento/DetalhesCase";
import LaboratorioDetalhesCaseTimeline from "../pages/Laboratorio/Acompanhamento/DetalhesCaseTimeline";
import LaboratorioRegistrarCase from "../pages/Laboratorio/Acompanhamento/RegistrarCase";
// --------
import SuprimentosProdutos from "../pages/Suprimentos/Produtos/Produtos";
import SuprimentosEstoque from "../pages/Suprimentos/Estoque/Estoque";
import SuprimentosEstoqueEntradas from "../pages/Suprimentos/Estoque/Entradas/Entradas";
import SuprimentosEstoqueAjustes from "../pages/Suprimentos/Estoque/Ajustes/Ajustes";
import SuprimentosEstoqueRetornos from "../pages/Suprimentos/Estoque/Retornos/Retornos";
import SuprimentosSaidas from "../pages/Suprimentos/Servicos/Servicos";
import SuprimentosPerdas from "../pages/Suprimentos/Perdas/Perdas";
import SuprimentosConsumos from "../pages/Suprimentos/Consumos/consumos";
import SuprimentosStandbyServico from "../pages/Suprimentos/Standby/Servico/Standby-servico";
import SuprimentosStandbyComercial from "../pages/Suprimentos/Standby/Comercial/Standby-comercial";
import SuprimentosStandbyConsumo from "../pages/Suprimentos/Standby/Consumo/Standby-consumo";
import RegistrarProduto from "../pages/Suprimentos/Produtos/RegistrarProduto";
import RegistrarProdutoV2 from "../pages/Suprimentos/Produtos/RegistrarProdutoV2";
import MovimentarProduto from "../pages/Suprimentos/Estoque/movimentacao/movimentacao";
import DetalhesProdutoPage from "../pages/Suprimentos/Produtos/DetalhesProdutoPrecos";
//
import SuprimentosProdutosCampos from "../pages/Suprimentos-Campos/Produtos/Produtos";
import SuprimentosEstoqueCampos from "../pages/Suprimentos-Campos/Estoque/Estoque";
import SuprimentosEstoqueEntradasCampos from "../pages/Suprimentos-Campos/Estoque/Entradas/Entradas";
import SuprimentosEstoqueAjustesCampos from "../pages/Suprimentos-Campos/Estoque/Ajustes/Ajustes";
import SuprimentosEstoqueRetornosCampos from "../pages/Suprimentos-Campos/Estoque/Retornos/Retornos";
import SuprimentosSaidasCampos from "../pages/Suprimentos-Campos/Servicos/Servicos";
import SuprimentosPerdasCampos from "../pages/Suprimentos-Campos/Perdas/Perdas";
import SuprimentosConsumosCampos from "../pages/Suprimentos-Campos/Consumos/consumos";
import SuprimentosStandbyServicoCampos from "../pages/Suprimentos-Campos/Standby/Servico/Standby-servico";
import SuprimentosStandbyComercialCampos from "../pages/Suprimentos-Campos/Standby/Comercial/Standby-comercial";
import SuprimentosStandbyConsumoCampos from "../pages/Suprimentos-Campos/Standby/Consumo/Standby-consumo";
import RegistrarProdutoCampos from "../pages/Suprimentos-Campos/Produtos/RegistrarProdutoV2";
import SuprimentosVendasCampos from "../pages/Suprimentos-Campos/Vendas/Vendas";
//
import SuprimentosVendas from "../pages/Suprimentos/Vendas/Vendas";
import SuprimentosEmbarcacoesClientes from "../pages/Coordenacao/EmbarcacoesClientes/embarcacoesCadastradas";
// Recursos-Humanos
import RecursosHumanosEstoque from "../pages/Recursos-Humanos/Estoque/Estoque";
import RecursosHumanosDEmpresa from "../pages/Recursos-Humanos/D-Empresa/d-empresa";
import RecursosHumanosProdutos from "../pages/Recursos-Humanos/Produtos/Produtos";
import RecursosHumanosStandby from "../pages/Recursos-Humanos/Standby/Standby-rh";
import RecursosHumanosSaidasConsumo from "../pages/Recursos-Humanos/Saidas/Consumos/consumos";
import RecursosHumanosSaidasPerda from "../pages/Recursos-Humanos/Saidas/Perdas/Perdas";
import RecursosHumanosEmpresasCadastradas from "../pages/Recursos-Humanos/Clientes/empresasCadastradas";
import MovimentarProdutoRecursosHumanos from "../pages/Recursos-Humanos/Movimentacao/movimentacao";
import RecursosHumanosColaboradores from "../pages/Recursos-Humanos/Colaboradores/colaboradores";
import RecursosHumanosRegistrarColaborador from "../pages/Recursos-Humanos/Colaboradores/registrar-colaborador";
import RecursosHumanosDetalhesColaborador from "../pages/Recursos-Humanos/Colaboradores/DetalhesColaborador";
import RecursosHumanosRegistrarProdutos from "../pages/Recursos-Humanos/Produtos/RegistrarProduto";
import RecursosHumanosAlterarDetalhesColaborador from "../pages/Recursos-Humanos/Colaboradores/editar-colaborador";
import RecursosHumanosDetalhesProduto from "../pages/Recursos-Humanos/Produtos/detalhesProduto";
import RecursosHumanosControleDePonto from "../pages/Recursos-Humanos/Controle-de-ponto/controle-de-ponto";
import SuprimentosEditarProduto from "../pages/Suprimentos/Produtos/EditarProduto";
// Tecnicos
import TecnicosProdutos from "../pages/Tecnicos/Produtos/Produtos";
import TecnicosEstoque from "../pages/Tecnicos/Estoque/Estoque";
import TecnicosEstoqueEntradas from "../pages/Tecnicos/Estoque/Entradas/Entradas";
import TecnicosEstoqueAjustes from "../pages/Tecnicos/Estoque/Ajustes/Ajustes";
import TecnicosEstoqueRetornos from "../pages/Tecnicos/Estoque/Retornos/Retornos";
import TecnicosSaidas from "../pages/Tecnicos/Servicos/Servicos";
import TecnicosPerdas from "../pages/Tecnicos/Perdas/Perdas";
import TecnicosConsumos from "../pages/Tecnicos/Consumos/consumos";
import TecnicosStandbyServico from "../pages/Tecnicos/Standby/Servico/Standby-servico";
import TecnicosStandbyConsumo from "../pages/Tecnicos/Standby/Consumo/Standby-consumo";
import TecnicosRegistrarProduto from "../pages/Tecnicos/Produtos/RegistrarProduto";
import TecnicosMovimentarProduto from "../pages/Tecnicos/Estoque/movimentacao/movimentacao";
import TecnicosDetalhesProdutoPage from "../pages/Tecnicos/Produtos/DetalhesProdutoPrecos";
// Diretoria
import DiretoriaEstoqueSuprimentos from "../pages/Diretoria/Suprimentos/Produtos/Produtos";
import DetalhesProdutoDiretoria from "../pages/Diretoria/DetalhesProduto";
import DiretoriaTecnicosMovimentarProduto from "../pages/Diretoria/Tecnicos/Estoque/movimentacao/movimentacao";
import DiretoriaRecursosHumanosMovimentarProduto from "../pages/Diretoria/Recursos-Humanos/Movimentacao/movimentacao";
// Coordenacao
import CoordenacaoColaboradores from "../pages/Coordenacao/Colaboradores/colaboradores";
import CoordenacaoStandby from "../pages/Coordenacao/Standby/Standby";
import CoordenacaoBaseDeClientes from "../pages/Coordenacao/EmpresasCadastradas/empresasCadastradas";
import RecursosHumanosRegistrarEmpresa from "../pages/Recursos-Humanos/Clientes/RegistrarEmpresaCliente";
import CoordenacaoProdutos from "../pages/Coordenacao/Produtos/Produtos";
import CoordenacaoSaidasServico from "../pages/Coordenacao/Saidas/saidas-servico";
import CoordenacaoEmbarcacoesClientes from "../pages/Coordenacao/EmbarcacoesClientes/embarcacoesCadastradas";
import CoordenacaoRegistrarEmbarcacoesClientes from "../pages/Coordenacao/EmbarcacoesClientes/RegistrarEmbarcacaoCliente";
// Comercial
import ComercialProdutos from "../pages/Comercial/Produtos/Produtos";
import ComercialStandby from "../pages/Comercial/Standby/Standby-comercial";
import ComercialVendas from "../pages/Comercial/Saidas/Vendas";
import DetalhesProdutoComercial from "../pages/Comercial/Produtos/DetalhesProduto";
// Suporte
import ProtectedRoute from "./ProtectedRoute";
import MenuConfigPage from "../pages/Config/menuConfig";
// -------
const LoginByDomain: React.FC = () => {
  const hostname = window.location.hostname.toLowerCase().replace(/^www\./, "");
  useEffect(() => {
    if (
      hostname === "eva.googlemarine.com" ||
      hostname.endsWith(".eva.googlemarine.com")
    ) {
      window.location.replace("https://logvi-havox.com");
    }
  }, [hostname]);
  if (
    hostname === "eva.googlemarine.com" ||
    hostname.endsWith(".eva.googlemarine.com")
  ) {
    return null;
  }

  if (hostname === "logvi-havox.com" || hostname.endsWith(".logvi-havox.com")) {
    return <AcessLoginHavox />;
  }
  return <AcessLoginHavox />;
};

const PdfRedirect: React.FC<{ file: string }> = ({ file }) => {
  useEffect(() => {
    window.location.replace(`/pdf/${file}`);
  }, [file]);
  return null;
};

function withCodigoGuard<C extends React.ComponentType<any>>(Component: C) {
  type Props = React.ComponentProps<C>;
  const Wrapped: React.FC<Props> = (props) => {
    const { codigo } = useParams<{ codigo: string }>();
    if (!codigo) {
      return <Navigate to="/entrar" replace />;
    }
    const onlyLetters = /^[A-Za-z]+$/.test(codigo);
    let isValid = false;
    if (onlyLetters) {
      isValid = true;
    } else {
      if (!/^[A-Za-z0-9]+$/.test(codigo)) {
        isValid = false;
      } else {
        const digits = (codigo.match(/\d/g) || []).length;
        isValid = digits <= 14;
      }
    }
    if (!isValid) {
      return <Navigate to="/entrar" replace />;
    }
    return <Component {...props} />;
  };
  Wrapped.displayName = `withCodigoGuard(${
    Component.displayName || Component.name || "Component"
  })`;

  return Wrapped;
}

const SuprimentosDetalhesGuard = withCodigoGuard(DetalhesProdutoPage);
const TecnicosDetalhesGuard = withCodigoGuard(TecnicosDetalhesProdutoPage);
const SuprimentosHistoricoGuard = withCodigoGuard(DetalhesProdutoPage);
const RhDetalhesGuard = withCodigoGuard(RecursosHumanosDetalhesProduto);
const DiretoriaDetalhesGuard = withCodigoGuard(DetalhesProdutoDiretoria);
const ComercialDetalhesGuard = withCodigoGuard(DetalhesProdutoComercial);

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Rotas públicas */}
      <Route path="/entrar" element={<LoginByDomain />} />
      <Route path="/assets/*" element={<AssetsServe />} />
      <Route
        path="/politicas/codigo-de-etica-e-conduta"
        element={<PdfRedirect file="HAVOX-CODIGO-DE-ETICA-E-CONDUTA.pdf" />}
      />
      <Route
        path="/politicas/politica-anticorrupcao-e-antissuborno"
        element={
          <PdfRedirect file="HAVOX-POLITICA-ANTICORRUPCAO-E-ANTISSUBORNO.pdf" />
        }
      />
      <Route path="/rastreamento/entrar" element={<AcessoRastreioHavox />} />
      <Route
        path="/Status-do-Servico/laboratorio"
        element={<AcessoRastreioMeusPedidosHavox />}
      />
      <Route
        path="/minhas-solicitacoes/laboratorio-cases"
        element={<AcessoRastreioMeusPedidosHavox />}
      />
      <Route path="/sessao-encerrada" element={<SessaoEncerrada />} />
      <Route path="/cadastro" element={<AcessCadastro />} />
      <Route path="/redefinir-senha" element={<AcessRecuperarSenha />} />
      {/* Documentação & mapa (ainda protegidos) */}
      <Route element={<ProtectedRoute />}>
        <Route
          path="/"
          element={<Navigate to="/suprimentos/produtos" replace />}
        />
        <Route path="/apidoc" element={<ApiDocPage />} />
        <Route path="/menu/config" element={<MenuConfigPage />} />
        <Route
          path="/coordenacao/colaboradores/visualizar-mapa"
          element={<MapViewPage />}
        />
        {/* ===== rotas com :codigo (com validação) ===== */}
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/produtos/:codigo"
          element={<SuprimentosDetalhesGuard />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/produtos/:codigo/editar"
          element={<SuprimentosEditarProduto />}
        />
        <Route
          path="/recursos-humanos/estoque-de-colaboradores/produtos/:codigo"
          element={<RhDetalhesGuard />}
        />
        <Route
          path="/diretoria/produtos/:codigo"
          element={<DiretoriaDetalhesGuard />}
        />
        <Route
          path="/comercial/produtos/:codigo"
          element={<ComercialDetalhesGuard />}
        />
        {/* ============================================= */}
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/produtos"
          element={<SuprimentosProdutos />}
        />

        <Route
          path="/laboratorio/gestao-de-cases"
          element={<LaboratorioGestaoDeCases />}
        />
        <Route
          path="/laboratorio/gestao-de-cases/detalhes-case/:codigo"
          element={<LaboratorioDetalhesCase />}
        />

        <Route
          path="/minhas-solicitacoes/laboratorio-cases/timeline/:codigo"
          element={<LaboratorioDetalhesCaseTimeline />}
        />
        <Route
          path="/laboratorio/gestao-de-cases/registrar-case"
          element={<LaboratorioRegistrarCase />}
        />

        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/estoque"
          element={<SuprimentosEstoque />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial"
          element={<SuprimentosEstoque />}
        />

        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/entradas"
          element={<SuprimentosEstoqueEntradas />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/entradas/ajustes"
          element={<SuprimentosEstoqueAjustes />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/entradas/retornos"
          element={<SuprimentosEstoqueRetornos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/saidas"
          element={<SuprimentosSaidas />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/saidas/servicos"
          element={<SuprimentosSaidas />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/saidas/vendas"
          element={<SuprimentosVendas />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/saidas/perdas"
          element={<SuprimentosPerdas />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/saidas/consumos"
          element={<SuprimentosConsumos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/standby/standby-servico"
          element={<SuprimentosStandbyServico />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/standby"
          element={<SuprimentosStandbyServico />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/standby/standby-comercial"
          element={<SuprimentosStandbyComercial />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/standby-consumo"
          element={<SuprimentosStandbyConsumo />}
        />
        <Route
          path="/suprimentos/embarcacoes"
          element={
            <SuprimentosEmbarcacoesClientes title="Suprimentos - Embarcações Cadastradas" />
          }
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/produtos/registrar-produto"
          element={<RegistrarProdutoV2 />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/estoque/realizar-movimentacao"
          element={<MovimentarProduto />}
        />
        {/*  */}
        {/* ===== rotas com :codigo (com validação) ===== */}

        <Route
          path="/suprimentos/estoque-p-uso-coorporativo/produtos/:codigo"
          element={<SuprimentosDetalhesGuard />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/produtos/:codigo"
          element={<SuprimentosDetalhesGuard />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-e-comercial/produtos/:codigo/editar"
          element={<SuprimentosEditarProduto />}
        />
        <Route
          path="/recursos-humanos/estoque-de-colaboradores/produtos/:codigo"
          element={<RhDetalhesGuard />}
        />
        <Route
          path="/diretoria/produtos/:codigo"
          element={<DiretoriaDetalhesGuard />}
        />
        <Route
          path="/comercial/produtos/:codigo"
          element={<ComercialDetalhesGuard />}
        />
        {/* ============================================= */}

        <Route
          path="/suprimentos/estoque-p-servico-campos/produtos/registrar-produto"
          element={<RegistrarProdutoCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/produtos"
          element={<SuprimentosProdutosCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos"
          element={<SuprimentosEstoqueCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/entradas"
          element={<SuprimentosEstoqueEntradasCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/entradas/ajustes"
          element={<SuprimentosEstoqueAjustesCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/entradas/retornos"
          element={<SuprimentosEstoqueRetornosCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/saidas"
          element={<SuprimentosSaidasCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/saidas/servicos"
          element={<SuprimentosSaidasCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/saidas/vendas"
          element={<SuprimentosVendasCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/saidas/perdas"
          element={<SuprimentosPerdasCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/saidas/consumos"
          element={<SuprimentosConsumosCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/standby/standby-servico"
          element={<SuprimentosStandbyServicoCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/standby"
          element={<SuprimentosStandbyServicoCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/standby/standby-comercial"
          element={<SuprimentosStandbyComercialCampos />}
        />
        <Route
          path="/suprimentos/estoque-p-servico-campos/standby-consumo"
          element={<SuprimentosStandbyConsumoCampos />}
        />

        <Route
          path="/suprimentos/estoque-p-servico-campos/produtos/registrar-produto"
          element={<RegistrarProdutoCampos />}
        />
        {/*  */}
        <Route
          path="/diretoria/estoque/realizar-movimentacao"
          element={<MovimentarProduto />}
        />
        <Route
          path="/diretoria/estoque-laboratorio/realizar-movimentacao"
          element={<DiretoriaTecnicosMovimentarProduto />}
        />
        <Route
          path="/diretoria/estoque-recursos-humanos/realizar-movimentacao"
          element={<DiretoriaRecursosHumanosMovimentarProduto />}
        />
        {/* Tecnicos */}
        <Route
          path="/Tecnicos&Laboratorio/produtos"
          element={<TecnicosProdutos />}
        />
        <Route
          path="/Tecnicos&Laboratorio/estoque"
          element={<TecnicosEstoque />}
        />
        <Route
          path="/Tecnicos&Laboratorio/estoque/entradas"
          element={<TecnicosEstoqueEntradas />}
        />
        <Route
          path="/Tecnicos&Laboratorio/estoque/ajustes"
          element={<TecnicosEstoqueAjustes />}
        />
        <Route
          path="/Tecnicos&Laboratorio/estoque/retornos"
          element={<TecnicosEstoqueRetornos />}
        />
        <Route
          path="/Tecnicos&Laboratorio/saidas/servicos"
          element={<TecnicosSaidas />}
        />
        <Route
          path="/Tecnicos&Laboratorio/saidas/perdas"
          element={<TecnicosPerdas />}
        />
        <Route
          path="/Tecnicos&Laboratorio/saidas/consumos"
          element={<TecnicosConsumos />}
        />
        <Route
          path="/Tecnicos&Laboratorio/standby"
          element={<TecnicosStandbyServico />}
        />
        <Route
          path="/Tecnicos&Laboratorio/standby-consumo"
          element={<TecnicosStandbyConsumo />}
        />
        <Route
          path="/Tecnicos&Laboratorio/produtos/registrar-produto"
          element={<TecnicosRegistrarProduto />}
        />
        <Route
          path="/Tecnicos&Laboratorio/estoque/realizar-movimentacao"
          element={<TecnicosMovimentarProduto />}
        />
        <Route
          path="/Tecnicos&Laboratorio/saidas"
          element={<TecnicosSaidas />}
        />
        {/* Recursos Humanos */}
        <Route
          path="/suprimentos/estoque-p-uso-coorporativo/produtos"
          element={<RecursosHumanosProdutos />}
        />
        <Route
          path="/suprimentos/estoque-p-uso-coorporativo/estoque/realizar-movimentacao"
          element={<MovimentarProdutoRecursosHumanos />}
        />
        <Route
          path="/suprimentos/estoque-p-uso-coorporativo/standby"
          element={<RecursosHumanosStandby />}
        />
        <Route
          path="/suprimentos/estoque-p-uso-coorporativo/saidas"
          element={<RecursosHumanosSaidasConsumo />}
        />
        <Route
          path="/suprimentos/estoque-p-uso-coorporativo/saidas/consumos"
          element={<RecursosHumanosSaidasConsumo />}
        />
        <Route
          path="/suprimentos/estoque-p-uso-coorporativo/saidas/perdas"
          element={<RecursosHumanosSaidasPerda />}
        />
        <Route
          path="/recursos-humanos/empresas-cadastradas"
          element={<RecursosHumanosEmpresasCadastradas />}
        />
        <Route
          path="/recursos-humanos/colaboradores"
          element={<RecursosHumanosColaboradores />}
        />
        <Route
          path="/coordenacao/colaboradores"
          element={<CoordenacaoColaboradores />}
        />
        <Route
          path="/recursos-humanos/colaboradores/registrar-colaborador"
          element={<RecursosHumanosRegistrarColaborador />}
        />
        <Route
          path="/recursos-humanos/colaborador/:id"
          element={<RecursosHumanosDetalhesColaborador />}
        />
        <Route
          path="/recursos-humanos/colaborador/:id/editar-colaborador"
          element={<RecursosHumanosAlterarDetalhesColaborador />}
        />
        <Route
          path="/suprimentos/estoque-p-uso-coorporativo/produtos/registrar-produto"
          element={<RecursosHumanosRegistrarProdutos />}
        />
        <Route
          path="/suprimentos/estoque-p-uso-coorporativo"
          element={<RecursosHumanosEstoque />}
        />
        <Route
          path="/suprimentos/estoque-p-uso-coorporativo/estoque"
          element={<RecursosHumanosEstoque />}
        />
        <Route
          path="/recursos-humanos/d.-empresa"
          element={<RecursosHumanosDEmpresa />}
        />
        {/* Diretoria */}
        <Route
          path="/diretoria/estoque-suprimentos"
          element={<DiretoriaEstoqueSuprimentos />}
        />
        {/* Coordenação */}
        <Route
          path="/coordenacao/coordenacao-rastreio-de-materiais"
          element={<CoordenacaoStandby />}
        />
        <Route
          path="/coordenacao/coordenacao-rastreio-de-materiais/standby"
          element={<CoordenacaoStandby />}
        />
        <Route
          path="/coordenacao/coordenacao-rastreio-de-materiais/produtos"
          element={<CoordenacaoProdutos />}
        />
        <Route
          path="/coordenacao/coordenacao-rastreio-de-materiais/saidas"
          element={<CoordenacaoSaidasServico />}
        />
        <Route
          path="/coordenacao/empresas-cadastradas"
          element={<CoordenacaoBaseDeClientes />}
        />
        <Route
          path="/coordenacao/embarcacoes"
          element={
            <CoordenacaoEmbarcacoesClientes title="Coordenação - Embarcações Cadastradas" />
          }
        />
        <Route
          path="/coordenacao/embarcacoes/registrar-embarcacao"
          element={<CoordenacaoRegistrarEmbarcacoesClientes />}
        />
        <Route
          path="/recursos-humanos/empresas-cadastradas/registrar-empresa"
          element={<RecursosHumanosRegistrarEmpresa />}
        />
        {/* Comercial */}
        <Route
          path="/comercial/materiais-p-venda"
          element={<ComercialProdutos />}
        />
        <Route
          path="/comercial/materiais-p-venda/produtos"
          element={<ComercialProdutos />}
        />
        <Route
          path="/comercial/materiais-p-venda/standby"
          element={<ComercialStandby />}
        />
        <Route
          path="/comercial/materiais-p-venda/saidas"
          element={<ComercialVendas />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/entrar" replace />} />
    </Routes>
  );
};

export default AppRoutes;
